// extracted by mini-css-extract-plugin
module.exports = {"main":"StopIndex_main__K_hxo","search-fade-in":"StopIndex_search-fade-in__xP4Cl"};